import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectWorkTypeValue } from '../../../../services/workTypes/selectors';

interface Props {
    isPieceRate?: ?boolean;
    children: React.Node;
}

export class WorkTypeIsPieceRateGate extends React.PureComponent<Props> {
    render() {
        const { isPieceRate, children } = this.props;
        if (!isPieceRate) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    isPieceRate: makeSelectWorkTypeValue('isPieceRate')
});

export default connect(mapStateToProps)(WorkTypeIsPieceRateGate);
